var FileWrapper = require('filewrapper');


var FileList = Backbone.Collection.extend({
    model: FileWrapper,
    initialize: function (models, options) {
        this.session = options.session;
    },
    comparator: function (file) {
        return -file.get('date');
    },
    getPages: function () {
        if (this.total) {
            return Math.ceil(this.total/this.per_page);
        }
    },
    fetch: function (page) {
        var data = {};
        if (page > 1) {
            data.page = page;
        }
        if (this.fetchComplete) {
            this.fetchComplete.reject();
        }
        var complete = this.session.getBackoff('files', data);
        this.fetchComplete = complete;
        return complete.done(_.bind(function (response) {
            this.total = response.total;
            this.per_page = response.per_page;
            this.page = response.page;
            this.set(response.files, {
                session: this.session
            });
            this.trigger('fetched');
        }, this));
    }
});


module.exports = FileList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/filelist.js
// module id = 66sV
// module chunks = 1